import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface ICompanyEditItem extends IEditItem {
    code: string;
    name: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    internet: string;
    pageFooterText: string;
    businessIdentityCode: string;
    contactPerson: string;
    logo: string;
    logoSquare: string;
    styleClass: string;
    fileStorageQuota: number;
    loginUrl: string;
    loginAllowMicrosoft: boolean;
    customStyleClass: string;
    tiedostoturvaUseType: number;
    activeState: number;
    documentRootPath: string;
    bannerPath: string;
    documentPreviewLogType: number;
    eInvoiceAddress: string;
    eInvoiceOperator: string;
    minPasswordLength: number;
    modifyUser: IModifyUser;
}

export class CompanyEditItem extends EditItem implements ICompanyEditItem {
    code: string;
    name: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    internet: string;
    pageFooterText: string;
    businessIdentityCode: string;
    contactPerson: string;
    logo: string;
    logoSquare: string;
    styleClass: string;
    customStyleClass: string;
    fileStorageQuota: number;
    loginUrl: string;
    loginAllowMicrosoft: boolean;
    tiedostoturvaUseType: number;
    activeState: number;
    documentRootPath: string;
    bannerPath: string;
    documentPreviewLogType: number;
    eInvoiceAddress: string;
    eInvoiceOperator: string;
    minPasswordLength: number;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: ICompanyEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.postalAddress = obj && obj.postalAddress || "";
        this.postalCode = obj && obj.postalCode || "";
        this.city = obj && obj.city || "";
        this.phone = obj && obj.phone || "";
        this.email = obj && obj.email || "";
        this.internet = obj && obj.internet || "";
        this.pageFooterText = obj && obj.pageFooterText || "";
        this.businessIdentityCode = obj && obj.businessIdentityCode || "";
        this.contactPerson = obj && obj.contactPerson || "";
        this.logo = obj && obj.logo || "";
        this.logoSquare = obj && obj.logoSquare || "";
        this.styleClass = obj && obj.styleClass || "";
        this.customStyleClass = obj && obj.customStyleClass || "";
        this.fileStorageQuota = obj && obj.fileStorageQuota || 0;
        this.loginUrl = obj && obj.loginUrl || "";
        this.loginAllowMicrosoft = obj && obj.loginAllowMicrosoft || false;
        this.tiedostoturvaUseType = obj && obj.tiedostoturvaUseType || 0;
        this.activeState = obj && obj.activeState || 0;
        this.documentRootPath = obj && obj.documentRootPath || "";
        this.bannerPath = obj && obj.bannerPath || "";
        this.documentPreviewLogType = obj && obj.documentPreviewLogType || 0;
        this.eInvoiceAddress = obj && obj.eInvoiceAddress || "";
        this.eInvoiceOperator = obj && obj.eInvoiceOperator || "";
        this.minPasswordLength = obj && obj.minPasswordLength || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}